'use client'

import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'
import { useCurrentLocale } from 'src/i18n/client/useCurrentLocale'

export const CookieItemOptions = ({ options }) => {
  const translateEntry = useTranslateEntry()
  const locale = useCurrentLocale()

  return (
    <div className="bg-basic-gray9 py-20 px-32 my-12">
      <ul className="list-none">
        <li className="grid grid-cols-[170px_120px_minmax(0,1fr)_200px_200px] text-left gap-x-16 py-16 border-b border-b-basic-gray6 max-t:hidden">
          <div className="font-sans text-body-b2 font-bold leading-[27px] text-dark-blue-dark-blue1">
            {translateEntry('COOKIE_ITEM_TITLE')}
          </div>
          <div className="font-sans text-body-b2 font-bold leading-[27px] text-dark-blue-dark-blue1">
            {translateEntry('COOKIE_ITEM_PROVIDER')}
          </div>
          <div className="font-sans text-body-b2 font-bold leading-[27px] text-dark-blue-dark-blue1">
            {translateEntry('COOKIE_ITEM_SHORTLEAD')}
          </div>
          <div className="font-sans text-body-b2 font-bold leading-[27px] text-dark-blue-dark-blue1">
            {translateEntry('COOKIE_ITEM_DATE')}
          </div>
          <div className="font-sans text-body-b2 font-bold leading-[27px] text-dark-blue-dark-blue1">
            {translateEntry('COOKIE_ITEM_KIND')}
          </div>
        </li>
        {options.map((option) => (
          <li
            className="grid t:grid-cols-[170px_120px_minmax(0,1fr)_200px_200px] text-left gap-x-16 py-16 border-b border-basic-gray6 last:border-b-0 max-t:gap-y-16"
            key={option.uuid}
          >
            <div className="max-t:flex max-t:flex-col max-t:gap-y-8">
              <span className="t:hidden font-sans text-body-b2 font-bold leading-[27px] text-dark-blue-dark-blue1">
                {translateEntry('COOKIE_ITEM_TITLE')}
              </span>
              <span className="font-sans text-body-b2 font-normal leading-[27px] text-dark-blue-dark-blue1">
                {option?.translations[locale]?.title}
              </span>
            </div>
            <div className="max-t:flex max-t:flex-col max-t:gap-y-8">
              <span className="t:hidden font-sans text-body-b2 font-bold leading-[27px] text-dark-blue-dark-blue1">
                {translateEntry('COOKIE_ITEM_PROVIDER')}
              </span>
              <span className="font-sans text-body-b2 font-normal leading-[27px] text-dark-blue-dark-blue1">
                {option?.translations[locale]?.provider}
              </span>
            </div>
            <div className="max-t:flex max-t:flex-col max-t:gap-y-8">
              <span className="t:hidden font-sans text-body-b2 font-bold leading-[27px] text-dark-blue-dark-blue1">
                {translateEntry('COOKIE_ITEM_SHORTLEAD')}
              </span>
              <span className="font-sans text-body-b2 font-normal leading-[27px] text-dark-blue-dark-blue1">
                {option?.translations[locale]?.shortLead}
              </span>
            </div>
            <div className="max-t:flex max-t:flex-col max-t:gap-y-8">
              <span className="t:hidden font-sans text-body-b2 font-bold leading-[27px] text-dark-blue-dark-blue1">
                {translateEntry('COOKIE_ITEM_DATE')}
              </span>
              <span className="font-sans text-body-b2 font-normal leading-[27px] text-dark-blue-dark-blue1">
                {option?.translations[locale]?.date}
              </span>
            </div>
            <div className="max-t:flex max-t:flex-col max-t:gap-y-8">
              <span className="t:hidden font-sans text-body-b2 font-bold leading-[27px] text-dark-blue-dark-blue1">
                {translateEntry('COOKIE_ITEM_KIND')}
              </span>
              <span className="font-sans text-body-b2 font-normal leading-[27px] text-dark-blue-dark-blue1">
                {option?.translations[locale]?.kind}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
